import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {Global} from '../../shared/variables'

const initialState = {
    monthlyRange: [],
    advance: [],
    totKm: [],
    period: [],
    models: [],
    fuels: [],
}

export const filterValuesSlice = createSlice({
    name: 'filterValues',
    initialState,
    reducers: {
        setMonthlyRange(
            state: RootState,
            action: PayloadAction<number[]>
        ): void {
            state.monthlyRange = action.payload
        },
        setAdvance(state: RootState, action: PayloadAction<string[]>): void {
            const advanceValues: string[] = []

            action.payload.map((advance: string) => {
                if (advance === Global.NO_ADVANCE) {
                    advanceValues.push(Global.NO_ADVANCE)
                } else if (advance === Global.ADVANCE) {
                    advanceValues.push(Global.ADVANCE)
                }
            })
            state.advance = advanceValues
        },
        setTotKm(state: RootState, action: PayloadAction<string[]>): void {
            const listToKms: number[] = []

            action.payload.map((km) => {
                listToKms.push(parseInt(km.replace(/[^0-9]/g, ''), 10))
            })

            state.totKm = listToKms
        },
        setPeriod(state: RootState, action: PayloadAction<string[]>): void {
            const slicedPeriod: number[] = []
            action.payload.map((period) => {
                slicedPeriod.push(parseInt(period.slice(0, 2)))
            })

            state.period = slicedPeriod
        },
        setModels(state: RootState, action: PayloadAction<string[]>): void {
            state.models = action.payload
        },
        setFuels(state: RootState, action: PayloadAction<string[]>): void {
            state.fuels = action.payload
        },
        resetFilterValues(state: RootState): void {
            state.monthlyRange = []
            state.advance = []
            state.totKm = []
            state.period = []
            state.models = []
            state.fuels = []
        },
    },
})

export const {
    setMonthlyRange,
    setModels,
    setAdvance,
    setPeriod,
    setFuels,
    setTotKm,
    resetFilterValues,
} = filterValuesSlice.actions

export default filterValuesSlice.reducer
